// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + chunkId + "." + {"19":"ad66f19026","49":"9ff2a4407f"}[chunkId] + ".js";
};